import { LEGE_BEWONER, LEGE_TUIN, type Registratie, type Woning } from '@/types/domain';
import { isHuurwoning } from '@/data/huurwoningen';
import { nieuweUuid } from '@/utils/id';
import { vandaagISO } from '@/utils/format';

/** Lege registratie voor een woning; het formulier vult deze verder. */
export function nieuweRegistratie(woning: Woning, coach: string): Registratie {
  const nu = new Date().toISOString();

  /*
   * Bij een huurwoning weten we het eigendom al; dat hoeft een coach niet uit
   * te vragen. Het afkoppelbesluit vullen we bewust NIET in: dat gaat over wat
   * de bewoner zelf doet, en dat is nog open. Dat de corporatie het pand
   * afkoppelt laat de driehoek op de kaart zien.
   */
  const huur = isHuurwoning(woning.adres);

  return {
    id: nieuweUuid(),
    bagId: woning.bagId,
    adres: { ...woning.adres },
    latitude: woning.latitude,
    longitude: woning.longitude,
    eigendom: huur ? 'Huur' : '',

    // Het eerste contactmoment is het bezoek waarvoor de coach nu voor de
    // deur staat. De gespiegelde velden hieronder volgen daaruit.
    contactmomenten: [
      {
        id: nieuweUuid(),
        datum: vandaagISO(),
        soort: 'Bezoek aan de deur',
        coach,
        uitkomst: '',
        toelichting: '',
      },
    ],

    datumBezoek: vandaagISO(),
    coach,
    uitkomstBezoek: '',
    uitkomstToelichting: '',

    bewoner: { ...LEGE_BEWONER },

    voortuin: { ...LEGE_TUIN, advies: [] },
    achtertuin: { ...LEGE_TUIN, advies: [] },

    afkoppelbesluit: '',
    maatregelenbesluit: '',
    subsidieStatus: '',
    realisatieStatus: '',
    datumVervolg: '',
    algemeneToelichting: '',

    fotos: [],

    aangemaaktOp: nu,
    gewijzigdOp: nu,
    versie: 1,
    syncState: 'pending',
  };
}

/**
 * Persoonsgegevens wissen wanneer de bewoner geen toestemming (meer) geeft.
 * De registratie zelf blijft bestaan; alleen de herleidbare velden gaan leeg.
 */
export function wisPersoonsgegevens(registratie: Registratie): Registratie {
  return {
    ...registratie,
    bewoner: { ...LEGE_BEWONER, toelichting: registratie.bewoner.toelichting },
  };
}
